module.exports = __webpack_public_path__ + "static/media/rescued.dad7219d.jpg";